import {ISelect} from '../../../../interface/ISelect';

export const productCodeType = {HSN: 'HSN', SAC: 'SAC'} as const;

export const isSacProduct = (
  productId: unknown,
  productsList: ISelect[]
): boolean =>
  productsList.find((p) => p.value === productId)?.type === productCodeType.SAC;

export const isSacProductInfoRecord = (
  productInfoRecordId: unknown,
  productFilter: ISelect[]
): boolean =>
  productFilter?.find((p) => p.value === productInfoRecordId)?.type ===
  productCodeType.SAC;

export const excludeSacProducts = (productsList: ISelect[]): ISelect[] =>
  productsList.filter((p) => p.type !== productCodeType.SAC);

export const ProductInfoKey = {
  PRODUCT_NAME: 'productId',
  VOLUME: 'volume',
  PRODUCT_TYPE: 'productType',
  FACILITIES: 'facilities',
  RAW_MATERIAL_DATA: 'rawMaterialsData',
  COST_TF: 'costtoproduction',
  SELLING_TF: 'sellingprice',
  UNIT_PRODUCED_TF: 'unitsproduced',
  SINGLE_FACILITY: 'facilityId',
  RAW_MATERIAL_ID: 'rawMaterialId',
  WEIGHT: 'weight',
  processType: 'processType'
};
export const ProductInfoLabel = {
  PRODUCT_NAME: 'Product / Service Name',
  VOLUME: 'Weight of each unit',
  PRODUCT_TYPE: 'Product / Service Type',
  FACILITIES: 'Facilities',
  RAW_MATERIAL_DATA: 'Raw Materials',
  COST_TF: 'Cost to production',
  SELLING_TF: 'Selling price',
  UNIT_PRODUCED_TF: 'Unit Produced',
  SINGLE_FACILITY: 'Facility',
  RAW_MATERIAL_ID: 'Raw Material',
  WEIGHT: 'Weight of each unit produce',
  processType: 'Process Type'
};
